import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {groupBy, isTeamMember} from '../../../helpers/utils';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import {LocationCustomerDashboard2} from './subComponents';
import dashboard from '../locales/dashboard.json';

class DashboardBox3 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			intervalId: '',
			locationCustomerDashboard: {
				totalOpenWorkOrders: 0,
				workOrders: [],
				inspections: {},
				inspectionsLast3days: {},
				inspectionsLast7days: {}
			}
		}
	}

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard);
		this.loadDashboard();

		const intervalId = setInterval(() => {
			this.loadDashboard();
		}, 300000);
		this.setState({intervalId: intervalId});
	}

	componentWillUnmount() {
		clearInterval(this.state.intervalId);
	}

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/3`);

			const totalOpenWorkOrders = response.data.total_open_work_orders;
			const workOrders = response.data.work_orders;
			const inspections = response.data.inspections;
			const inspectionsLast3days = response.data.inspections_last_3_days;
			const inspectionsLast7days = response.data.inspections_last_7_days;

			this.setState({
				locationCustomerDashboard: {
					...this.state.locationCustomerDashboard,
					totalOpenWorkOrders: totalOpenWorkOrders,
					workOrders: workOrders,
					inspections: groupBy(inspections, 'work_order_id'),
					inspectionsLast3days: groupBy(inspectionsLast3days, 'work_order_id'),
					inspectionsLast7days: groupBy(inspectionsLast7days, 'work_order_id')
				}
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					{
						<LocationCustomerDashboard2 state={this.state.locationCustomerDashboard} permissionNames={permissionNames} translate={translate}
						                           enableViewInspection={!(isTeamMember(session))}
						/>
					}
				</section>
			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox3);
